import { render, staticRenderFns } from "./_base-filters-wrapper.vue?vue&type=template&id=1beb4446&"
import script from "./_base-filters-wrapper.vue?vue&type=script&lang=js&"
export * from "./_base-filters-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports